import {
  SURFACE_PAGE_TAB_ACTIVE,
  SURFACE_PAGE_TAB_INACTIVE,
} from '@/shared/ui-class';
import { cn } from '@/shared/cn';

export type SurfacePageTabItem<T extends string = string> = {
  id: T;
  label: string;
};

export type SurfacePageTabsProps<T extends string> = {
  /** Set by `<Commentable>` (cloneElement); forwarded to the root element so the anchor reaches the DOM. */
  'data-comment-anchor'?: string;
  items: readonly SurfacePageTabItem<T>[];
  value: T;
  onChange: (next: T) => void;
  'aria-label'?: string;
  className?: string;
};

/** Pill tab row for Interior surface toolbars. Active tab = filled neutral pill. */
export function SurfacePageTabs<T extends string>({
  items,
  value,
  onChange,
  'aria-label': ariaLabel,
  className,
  'data-comment-anchor': commentAnchor,
}: SurfacePageTabsProps<T>) {
  return (
    <div
      role="tablist"
      data-comment-anchor={commentAnchor}
      aria-label={ariaLabel}
      className={cn('flex flex-wrap items-center gap-1', className)}
    >
      {items.map((item) => {
        const active = item.id === value;
        return (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(item.id)}
            className={cn(active ? SURFACE_PAGE_TAB_ACTIVE : SURFACE_PAGE_TAB_INACTIVE)}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
